var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestopsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30.69px",
    height: "30.69px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo/28px/Colored/Full"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Testops_icon"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-43",
    fill: "#5CCEFF",
    points: "7.38964445e-13 26 13 26 12.9978339 20.8028643 26 0 7.38964445e-13 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-33",
    fill: "#4D94FF",
    transform: "translate(15.973776, 17.333333) scale(-1, 1) translate(-15.973776, -17.333333) ",
    points: "5.94755234 26 20.5315846 26 26 17.1819944 16.7452065 8.66666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88421053,6.5 L13.2683582,6.5 C14.5763109,6.5 15.8306933,7.0195822 16.7555556,7.94444444 C17.6804178,8.86930669 18.2,10.1236891 18.2,11.4316418 L18.2,18.8157895 C18.2,19.1936685 17.8936685,19.5 17.5157895,19.5 L10.1316418,19.5 C8.82368908,19.5 7.56930669,18.9804178 6.64444444,18.0555556 C5.7195822,17.1306933 5.2,15.8763109 5.2,14.5683582 L5.2,7.18421053 C5.2,6.80633149 5.50633149,6.5 5.88421053,6.5 Z",
    id: "Rectangle-Copy-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "To",
    fill: "#4D94FF",
    fillRule: "nonzero",
    points: "8.45 9.1 14.95 9.1 14.95 10.9942857 12.7646552 10.9942857 12.7646552 16.9 10.6353448 16.9 10.6353448 10.9942857 8.45 10.9942857"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestopsIcon);
export default __webpack_public_path__ + "static/media/testops_icon.7b846fdd588e63e3d905d9515341bff4.svg";
export { ForwardRef as ReactComponent };